import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
} from "node-library/dist/portal";
import ViewOrdersTableListView from "./viewOrdersTableListView";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { useEffect, useState } from "react";
import AdminViewOrdersTableGridView from "./admin_grid_view/adminViewOrdersTableGridView";

interface Props {
	orders: Array<FrontendProductOrder>;
	user: FrontendUserInfo | undefined;
	isInAdminView: boolean;
	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	deleteOrder: (order: FrontendProductOrder) => void;
	goToViewOrderDetails: (order: FrontendProductOrder) => void;
	goToEditOrderPage: (order: FrontendProductOrder) => void;
	goToOrderReportPage: (order: FrontendProductOrder) => void;
	viewOrderCOC: (order: FrontendProductOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function AdminClientOrderContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		orders,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		deleteOrder,
		goToViewOrderDetails,
		goToEditOrderPage,
		goToOrderReportPage,
		setDiscardOrderConfirmOpen,
		viewOrderCOC,
		setProceedAction,
	} = props;

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 600);
		};

		// Set the initial screen size on mount
		handleResize();

		// Listen for window resize
		window.addEventListener("resize", handleResize);

		// Clean up the event listener
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{orders.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div className="no-order-icon"></div>

					<div
						className="typography-body-01 typography-bold"
						style={{ marginTop: "20px" }}
					>
						{translation("NoOrder")}
					</div>
					<div
						className="typography-body-02"
						style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
					>
						{translation("AdminNoOrderDescription")}
					</div>
				</div>
			) : isMobile ? (
				<AdminViewOrdersTableGridView
					orders={orders}
					user={props.user}
					deleteOrder={deleteOrder}
					viewOrderCOC={viewOrderCOC}
					goToOrderReportPage={goToOrderReportPage}
					goToViewOrderDetails={goToViewOrderDetails}
					goToEditOrderPage={goToEditOrderPage}
					setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
					setProceedAction={setProceedAction}
				/>
			) : (
				<ViewOrdersTableListView
					orders={orders}
					user={props.user}
					isInAdminView={props.isInAdminView}
					deleteOrder={deleteOrder}
					viewOrderCOC={viewOrderCOC}
					goToOrderReportPage={goToOrderReportPage}
					goToViewOrderDetails={goToViewOrderDetails}
					goToEditOrderPage={goToEditOrderPage}
					setDiscardOrderConfirmOpen={setDiscardOrderConfirmOpen}
					setProceedAction={setProceedAction}
				/>
			)}
		</div>
	);
}
